import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import CompaniesBilling from "./CompaniesBilling";
import FinancialStatement from "./FinancialStatement";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  tabs: {
    marginBottom: theme.spacing(2),
  },
}));

export default function BillingManager() {
  const classes = useStyles();
  const [view, setView] = useState("companies");

  return (
    <div className={classes.root}>
      <Paper variant="outlined" className={classes.tabs}>
        <Tabs
          value={view}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, v) => setView(v)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label={i18n.t("billingManager.tabs.companies")} value="companies" />
          <Tab label={i18n.t("billingManager.tabs.statement")} value="statement" />
        </Tabs>
      </Paper>

      {view === "companies" ? <CompaniesBilling /> : <FinancialStatement />}
    </div>
  );
}
